import { AbstractControl, Validators, ValidatorFn } from '@angular/forms';

export class CustomValidators extends Validators {

    static requiredDropdown(initialValue: any): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const selectedValue: string = <string>control.value;
            if (((selectedValue + '') == (initialValue + '')) && control.touched) {
                return { 'requiredDropdown': true };
            } else {
                return null;
            }
        };
    }
}
